import React, { useEffect, useState, useRef } from "react";
import $ from "jquery"; // Importer jQuery
import "datatables.net-bs5"; // Importer DataTables avec Bootstrap 5
import "datatables.net-responsive-bs5"; // Importer le plugin Responsive de DataTables
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; // Importer le CSS de DataTables Bootstrap 5
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // Importer le CSS du plugin Responsive
import "bootstrap/dist/css/bootstrap.min.css"; // Importer Bootstrap CSS
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faShare } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";
import { Card, Modal, Nav, Tab, Form, Button, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { format } from "date-fns";
import fr from "date-fns/locale/fr";
import axiosInstance from "../../api/axiosInstance";
import { faFilter } from "@fortawesome/free-solid-svg-icons";

// Separate Modal Component
const JobOfferModal = ({ show, handleClose, offre }) => {
  const [documents, setDocuments] = useState([]);

  const [activeTab, setActiveTab] = useState("tab1");
  const [formData, setFormData] = useState({});
  const [showAddModal, setShowAddModal] = useState(false);
  const handleOpenAddModal = () => setShowAddModal(true);
  const tableRef = useRef(null);
  const dataTableInitialized = useRef(false); // Vérifier si DataTable est déjà initialisé
  const dataTableInstance = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [saveError, setSaveError] = useState(null);
  //modal ajouter document
  const handleShowAddModal = () => setShowAddModal(true);
  const handleCloseAddModal = () => setShowAddModal(false);
  const [selfile, setFile] = useState(null);
  const [seltitre_document, setTitreDocument] = useState("");
  const [sellangue, setLangue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showCard, setShowCard] = useState(false);

  const typeOptions = [
    { value: "Français", label: "Français" },
    { value: "Anglais", label: "Anglais" },
    { value: "Arabe", label: "Arabe" },
  ];

  useEffect(() => {
    if (offre) {
      setFormData({
        titre: offre.titre,
        type_offre: offre.type_offre,
        description: offre.description,
        date_mise_en_ligne: offre.date_mise_en_ligne,
        date_limite: offre.date_limite,
        si_fixe: offre.si_national,
        lieu: offre.lieu,
        id: offre.id,
        titre_document: offre.titre_document,
        titre_entreprise: offre.titre_entreprise,
        groupement_spacial: offre.groupement_spacial,
        titre_groupement_cpacial: offre.titre_groupement_cpacial,
        titre_groupement_special_arabe: offre.titre_groupement_special_arabe,
        titre_ar: offre.titre_ar,
        titre_entreprise_ar: offre.titre_entreprise_ar,
        titre_documents_ar: offre.titre_documents_ar,
        description_ar: offre.description_ar,
        message_ar: offre.message_ar,
      });
    }
  }, [offre]);

  // const saveJobOffer = async () => {
  //   setIsSaving(true);
  //   setSaveError(null);
  //   setSaveSuccess(false);

  //   try {
  //     const response = await axios.put(
  //       `http://localhost:8000/avis_infos/api/offres/${formData.id}/`,
  //       formData,
  //       {
  //         headers: { "Content-Type": "application/json" },
  //       }
  //     );
  //     setSaveSuccess(true);
  //   } catch (error) {
  //     setSaveError("Erreur de sauvegarde: " + (error.response?.data?.detail || error.message));
  //   } finally {
  //     setIsSaving(false);
  //   }
  // };

  const saveJobOffer = async () => {
    setIsSaving(true);
    setSaveError(null);
    setSaveSuccess(false);

    try {
      const response = await axiosInstance.put(
        `/avis_infos/api/offres/${formData.id}/`,
        formData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      setSaveSuccess(true);
    } catch (error) {
      setSaveError(
        "Erreur de sauvegarde: " +
          (error.response?.data?.detail || error.message)
      );
    } finally {
      setIsSaving(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleEditorChange = (content, name) => {
    setFormData({ ...formData, [name]: content });
  };

  const handleSubmit = (e, tab) => {
    e.preventDefault();
    console.log(`Submitting form for ${tab}:`, formData);
    // Add API call here to submit data
  };

  const fetchDocuments = async () => {
    if (!offre) return;
    setIsLoading(true);

    try {
      const response = await axiosInstance.get(
        `/avis_infos/api/documents/${offre.id}/`
      );
      setDocuments(response.data.documents);
    } catch (error) {
      console.error("Erreur lors du chargement des documents:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [offre]);

  useEffect(() => {
    if (activeTab === "tab3") {
      const table = $("#documentsTable").DataTable({
        responsive: true,
        destroy: true,
      });

      return () => {
        table.destroy();
      };
    }
  }, [activeTab]);

  const handleDocumentSubmit = async (e) => {
    e.preventDefault();

    if (!selfile || !seltitre_document || !sellangue) {
      console.error("Tous les champs sont requis !");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("piece_join", selfile); // fichier
      formData.append("titre_document", seltitre_document);
      formData.append("langue", sellangue);

      const response = await fetch(
        `http://localhost:8000/avis_infos/ajouter_document_client/${offre.id}/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: formData, // Envoi des données
        }
      );

      const data = await response.json();
      if (response.ok) {
        fetchDocuments();
        console.log("Document ajouté :", data);

        setShowCard(false);
      } else {
        setMessage("Échec de l'ajout du Document.");
        setTimeout(() => setMessage(""), 20000);
      }
    } catch (error) {
      setMessage("Une erreur est survenue.");
      setTimeout(() => setMessage(""), 10000);
    }
  };

  // Fonction pour supprimer un document
  const deleteDocument = async (documentId) => {
    if (!window.confirm("Voulez-vous vraiment supprimer ce document ?")) return;

    try {
      const response = await axiosInstance.delete(
        `/avis_infos/api/documents/delete/${documentId}/`
      );
      if (response.data.error) {
        alert("Erreur : " + response.data.error);
      } else {
        alert("Document supprimé !");
        setDocuments(documents.filter((doc) => doc.id !== documentId)); // Mise à jour de l’état
        fetchDocuments();
      }
    } catch (error) {
      console.error("Erreur :", error);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          <b>
            Appels d'offre :{" "}
            <div dangerouslySetInnerHTML={{ __html: formData.titre }} />
          </b>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tab.Container
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          mountOnEnter
          unmountOnExit
        >
          <Nav variant="tabs" className="main-tabs">
            <Nav.Item>
              <Nav.Link eventKey="tab1">
                <i className="fa fa-info-circle"></i> Info
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="tab2">
                <i className="fa fa-language"></i> Traduction en arabe
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="tab3">
                <i className="far fa-file-pdf"></i> GED
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="tab1" className="p-1">
              <Form onSubmit={(e) => handleSubmit(e, "tab1")}>
                <br /> <br />
                {/* Titre */}
                <Form.Group className="mb-4">
                  <Form.Label
                    className="ms-1"
                    style={{ fontSize: "16px", color: "#858796" }}
                  >
                    Titre <span style={{ color: "black" }}>*</span>
                  </Form.Label>
                  <Editor
                    apiKey="klj83yy4j4btu0s11oheti6rj6kwwgj0lnbtwunqvvqeipyf"
                    value={formData.titre}
                    init={{
                      height: 400,
                      menubar: true,
                      plugins: "table lists",
                      toolbar:
                        "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist",
                    }}
                    onEditorChange={(content) =>
                      handleEditorChange(content, "titre")
                    }
                  />
                </Form.Group>
                {/* Description */}
                <Form.Group className="mb-4">
                  <Form.Label
                    className="ms-1"
                    style={{ fontSize: "16px", color: "#858796" }}
                  >
                    Description <span style={{ color: "black" }}>*</span>
                  </Form.Label>
                  <Editor
                    apiKey="klj83yy4j4btu0s11oheti6rj6kwwgj0lnbtwunqvvqeipyf"
                    value={formData.description}
                    init={{
                      height: 445,
                      menubar: true,
                      plugins: "table lists",
                      toolbar:
                        "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist",
                    }}
                    onEditorChange={(content) =>
                      handleEditorChange(content, "description")
                    }
                  />
                </Form.Group>
                {/* Dates */}
                <Row>
                  <Col md={6} style={{ paddingRight: "20px" }}>
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="ms-1"
                        style={{ fontSize: "16px", color: "#858796" }}
                      >
                        Date de mise en ligne{" "}
                        <span style={{ color: "black" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="date_mise_en_ligne"
                        value={formData.date_mise_en_ligne}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="ms-1"
                        style={{ fontSize: "16px", color: "#858796" }}
                      >
                        Date limite <span style={{ color: "black" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="date_limite"
                        value={formData.date_limite}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                {/* Avis fixe & Entreprise */}
                <Row>
                  <Col md={6} style={{ paddingRight: "20px" }}>
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="ms-1"
                        style={{ fontSize: "16px", color: "#858796" }}
                      >
                        Avis fixe <span style={{ color: "black" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        name="si_national"
                        value={formData.si_national}
                        onChange={handleInputChange}
                      >
                        <option value="1">Oui</option>
                        <option value="2">Non</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="ms-1"
                        style={{ fontSize: "16px", color: "#858796" }}
                      >
                        Titre entreprise{" "}
                        <span style={{ color: "black" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="titre_entreprise"
                        value={formData.titre_entreprise}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                {/* Document & Groupement spécial */}
                <Row>
                  <Col md={6} style={{ paddingRight: "20px" }}>
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="ms-1"
                        style={{ fontSize: "16px", color: "#858796" }}
                      >
                        Titre des documents{" "}
                        <span style={{ color: "black" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="titre_document"
                        value={formData.titre_document}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="ms-1"
                        style={{ fontSize: "16px", color: "#858796" }}
                      >
                        Groupement spécial{" "}
                        <span style={{ color: "black" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        name="groupement_spacial"
                        value={formData.groupement_spacial}
                        onChange={handleInputChange}
                      >
                        <option value="0">Non</option>
                        <option value="1">Oui</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                {/* Titre groupement & Arabe */}
                <Row>
                  <Col md={6} style={{ paddingRight: "20px" }}>
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="ms-1"
                        style={{ fontSize: "16px", color: "#858796" }}
                      >
                        Titre groupement spécial{" "}
                        <span style={{ color: "black" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="titre_groupement_cpacial"
                        value={formData.titre_groupement_cpacial}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="ms-1"
                        style={{ fontSize: "16px", color: "#858796" }}
                      >
                        Titre groupement spécial arabe{" "}
                        <span style={{ color: "black" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="titre_groupement_special_arabe"
                        value={formData.titre_groupement_special_arabe}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                {/* Lien */}
                <Row>
                  <Col md={6} style={{ paddingRight: "20px" }}>
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="ms-1"
                        style={{ fontSize: "16px", color: "#858796" }}
                      >
                        Lien <span style={{ color: "black" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="lien"
                        value={formData.lien}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                {/* Bouton */}
                <div className="text-end">
                  <Button
                    variant="success"
                    onClick={saveJobOffer}
                    disabled={isSaving}
                  >
                    {isSaving ? "Sauvegarde..." : "Enregistrer"}
                  </Button>
                </div>
              </Form>
            </Tab.Pane>

            <Tab.Pane eventKey="tab2">
              <Form onSubmit={(e) => handleSubmit(e, "tab2")}>
                <Form.Group className="mb-3">
                  <Form.Label
                    className=""
                    style={{ fontSize: "16px", color: "#858796" }}
                  >
                    Titre en arabe <span className="">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="titre_ar"
                    value={formData.titre_ar}
                    onChange={handleInputChange}
                  />
                </Form.Group>

                <Row>
                  <Col md={6} style={{ paddingRight: "15px" }}>
                    <Form.Group className="mb-3 ms-3">
                      <Form.Label
                        className=""
                        style={{ fontSize: "16px", color: "#858796" }}
                      >
                        Titre entreprise ar
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="titre_entreprise_ar"
                        value={formData.titre_entreprise_ar}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} style={{ paddingRight: "13px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        className=""
                        style={{ fontSize: "16px", color: "#858796" }}
                      >
                        Titre des documents en arabe
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="titre_documents_ar"
                        value={formData.titre_documents_ar}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label
                    className="ms-1"
                    style={{ fontSize: "16px", color: "#858796" }}
                  >
                    Description en arabe <span className="">*</span>
                  </Form.Label>
                  <Editor
                    apiKey="klj83yy4j4btu0s11oheti6rj6kwwgj0lnbtwunqvvqeipyf"
                    value={formData.description_ar}
                    init={{
                      height: 400,
                      menubar: true,
                      plugins: "table lists",
                      toolbar:
                        "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist",
                    }}
                    onEditorChange={(content) =>
                      handleEditorChange(content, "description_ar")
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label
                    className="ms-1"
                    style={{ fontSize: "16px", color: "#858796" }}
                  >
                    Message Ar <span className="">*</span>
                  </Form.Label>
                  <Editor
                    apiKey="klj83yy4j4btu0s11oheti6rj6kwwgj0lnbtwunqvvqeipyf"
                    value={formData.message_ar}
                    init={{
                      height: 400,
                      menubar: true,
                      plugins: "table lists",
                      toolbar:
                        "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist",
                    }}
                    onEditorChange={(content) =>
                      handleEditorChange(content, "message_ar")
                    }
                  />
                </Form.Group>

                <div className="text-end">
                  <Button
                    variant="success"
                    type="submit"
                    onClick={saveJobOffer}
                    disabled={isSaving}
                  >
                    <i className="fas fa-save"></i>{" "}
                    {isSaving ? "Saving..." : "Save"}
                  </Button>
                </div>
              </Form>
            </Tab.Pane>
            <Tab.Pane eventKey="tab3">
              <section className="container mt-4">
                <div>
                  {message && <div className="message">{message}</div>}
                  <Button
                    className="btn"
                    style={{ width: "200px" }}
                    variant="primary"
                    onClick={() => setShowCard(true)}
                  >
                    Nouveau document
                  </Button>
                </div>
                <br />
                <br />

                {showCard && (
                  <div className="d-flex justify-content-center">
                    <Card
                      className="mb-3 "
                      style={{ width: "100%", maxWidth: "1000px", zIndex: 10 }}
                    >
                      <Card.Header
                        className="d-flex justify-content-between align-items-center"
                        style={{ background: "#F8F9FC", color: "#858796" }}
                      >
                        <h5 className="mb-0">Nouveau document</h5>
                        <Button
                          onClick={() => setShowCard(false)}
                          className=""
                          style={{
                            background: "#F8F9FC",
                            color: "#858796",
                            maxWidth: "100px",
                            border: "none", // Supprime la bordure
                            boxShadow: "none", // Supprime l'ombre au focus
                          }}
                        >
                          ×
                        </Button>
                      </Card.Header>
                      <Card.Body
                        className=""
                        style={{
                          width: "100%",
                          maxWidth: "1000px",
                          zIndex: 10,
                        }}
                      >
                        <Form onSubmit={handleDocumentSubmit}>
                          <Form.Group className="mb-3">
                            <Form.Label
                              className="ms-3"
                              style={{ fontSize: "16px", color: "#858796" }}
                            >
                              Fichier <span className="">*</span>
                            </Form.Label>
                            <Form.Control
                              type="file"
                              onChange={(e) => setFile(e.target.files[0])}
                              accept=".pdf,.doc,.docx,.xls,.xlsx"
                            />
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label
                              className="ms-3"
                              style={{ fontSize: "16px", color: "#858796" }}
                            >
                              Libellé <span className="">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={seltitre_document}
                              onChange={(e) => setTitreDocument(e.target.value)}
                            />
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label
                              className="ms-3"
                              style={{ fontSize: "16px", color: "#858796" }}
                            >
                              Langue <span className="">*</span>
                            </Form.Label>
                            <Form.Select
                              value={sellangue}
                              onChange={(e) => setLangue(e.target.value)}
                            >
                              <option value="">Sélectionner une langue</option>
                              {typeOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>

                          <div className="text-end">
                            <Button variant="success" type="submit">
                              Ajouter
                            </Button>
                          </div>
                        </Form>
                      </Card.Body>
                    </Card>
                  </div>
                )}
                <br />
                <br />
                <div
                  className="text-center card shadow-sm"
                  style={{ maxWidth: "100%" }}
                >
                  <div className="card-bod" style={{ fontSize: "11px" }}>
                    <table
                      id="documentsTable"
                      className="table table-striped table-bordered"
                    >
                      <thead>
                        <tr>
                          <th>Libellé</th>
                          <th>langue</th>
                          <th>Extension</th>
                          <th>Taille (Octets)</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {documents.map((doc) => (
                          <tr key={doc.id}>
                            <td>{doc.titre_document}</td>
                            <td>{doc.langue}</td>
                            <td>{doc.extension}</td>
                            <td>{doc.taille}</td>
                            <td>
                              <div className="btn-group">
                                {/* Bouton Voir */}
                                <a
                                  href={doc.piece_join_url}
                                  className="btn btn-sm "
                                  style={{
                                    backgroundColor: "#5A5C69",
                                  }}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="Voir fichier"
                                >
                                  <i className="fa fa-fw fa-eye"></i>
                                </a>

                                {/* Bouton Supprimer */}
                                <button
                                  className="btn btn-sm "
                                  style={{
                                    backgroundColor: "#858796",
                                  }}
                                  onClick={() => deleteDocument(doc.id)}
                                  title="Supprimer"
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>
    </Modal>
  );
};

const AnnouncementTypeChanger = ({ showModal, handleClose, offreId }) => {
  const [selectedType, setSelectedType] = useState(null);
  const [message, setMessage] = useState("");

  const typeOptions = [
    { value: "OFFRE_EMPLOI", label: "OFFRE_EMPLOI" },
    { value: "Consultants", label: "Consultants" },
    { value: "Internationaux", label: "Appels d'offres internationaux" },
    { value: "Locaux", label: "Appels d'offres locaux" },
    { value: "Consultations", label: "Consultations" },
    { value: "Manifestations", label: "Manifestations d’Intérêts" },
    { value: "Avisinfos", label: "Avis & infos" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedType) {
      alert("Veuillez sélectionner un type d'offre.");
      return;
    }

    try {
      const response = await axiosInstance.put(
        `/offres/modifier_type/${offreId}/`,
        {
          type_offre: selectedType.value,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      console.log("✅ Type d'offre modifié :", response.data);
      handleClose(); // Fermer la modal si nécessaire
    } catch (error) {
      if (error.response) {
        console.error("❌ Erreur API :", error.response.data);
      } else {
        console.error("❌ Erreur de connexion :", error.message);
      }
    }
  };

  return (
    <Modal show={showModal} onHide={handleClose} backdrop={false}>
      {message && <div className="message">{message}</div>}
      <Modal.Header closeButton>
        <Modal.Title>Modifier le type d'annonce</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-4">
            <Form.Label>Nouveau type :</Form.Label>
            <Select
              options={typeOptions}
              value={selectedType}
              onChange={setSelectedType}
              placeholder="Sélectionnez un type"
              isSearchable
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={handleClose}>
              Annuler
            </Button>
            <Button variant="primary" type="submit">
              Confirmer
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

const AvisInfos = ({ avisInfos = [], clientId }) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedOffre, setSelectedOffre] = useState(null);
  const [titreContent, setTitreContent] = useState("");
  const [descriptionContent, setDescriptionContent] = useState("");
  const [typeAnnonce, setTypeAnnonce] = useState("1");
  const [lieu, setLieu] = useState("");
  const [showLieuInput, setShowLieuInput] = useState(false);
  const [si_fixe, setSi_fixe] = useState("1");
  const [lien, setLien] = useState("");
  const [message, setMessage] = useState("");

  const handleTypeChange = (event) => {
    const newValue = event.target.value;
    setSi_fixe(newValue);
    console.log("Type d'offre changé en :", newValue === "1" ? "Non" : "Oui");
  };

  const handleLienChange = (e) => {
    setLien(e.target.value);
  };

  const handleOpenAddModal = () => setShowAddModal(true);
  const handleCloseAddModal = () => setShowAddModal(false);
  const handleOpenDetailModal = (offre) => {
    setSelectedOffre(offre);
    setShowDetailModal(true);
  };
  const handleCloseDetailModal = () => setShowDetailModal(false);
  const handleShow = (offre) => {
    setSelectedOffre(offre);
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
    setSelectedOffre(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      titre: titreContent,
      description: descriptionContent,
      type_offre: typeAnnonce,
      date_limite: new Date(
        document.getElementById("date_limite").value
      ).toISOString(),
      si_fixe: si_fixe === "2",
      lien,
    };

    try {
      const response = await axiosInstance.post(
        `/avis_infos/offres/ajouter/${clientId}/`,
        formData
      );
      const offreId = response.data.offre_id;
      console.log(offreId )
      setMessage("Avis ajouté avec succès !");
      setTimeout(() => setMessage(""), 20000);
      handleCloseAddModal();
      handleOpenDetailModal({ ...formData, id: offreId });
      
    } catch (error) {
      setMessage("Échec de l'ajout de l'avis.");
      setTimeout(() => setMessage(""), 20000);
    }
  };

  const filterAvis = () => {
    const etat = $("#etat").val();
    const table = $("#avisInfosTable").DataTable();

    table.columns().search("").draw();

    if (etat !== "all") {
      if (etat === "2") {
        table.column(4).search("false").draw(); // si_valider = false
      } else if (etat === "3") {
        table.column(4).search("true").draw(); // si_valider = true
      } else if (etat === "10") {
        table.column(5).search("true").draw(); // si_archiver = true
      }
    }
  };

  useEffect(() => {
    $.fn.dataTable.ext.errMode = "none";

    if (avisInfos.length > 0) {
      const table = $("#avisInfosTable").DataTable({
        responsive: true,
        destroy: true,
        data: avisInfos,
        columns: [
          { data: "titre" },
          {
            data: "date_limite",
            render: (data) =>
              data
                ? format(new Date(data), "dd/MM/yyyy", { locale: fr })
                : "N/A",
          },
          { data: "client__nom", defaultContent: "" },
          {
            data: null,
            orderable: false,
            render: function (data, type, row) {
              return `
                  <div style="display: flex; justify-content: center; gap: 2px;">
                    <button class="btn btn-danger" style="padding: 5px 2px 2px 2px; font-size: 10px; width: 23px; border-radius: 4px 0 0 4px;" data-id="${row.id}" data-action="changer" data-toggle="tooltip" data-placement="top" title="Changer le type d'annonce">
                      <i class="fa fa-info-circle"></i>
                    </button>
                    <button class="btn btn-secondary" style="padding: 5px 2px 2px 2px; font-size: 10px; width: 23px; background-color: #5A5C69; border-radius: 0 4px 4px 0;" data-id="${row.id}" data-action="visualiser" data-toggle="tooltip" data-placement="top" title="Visualiser">
                      <i class="fa fa-eye"></i>
                    </button>
                  </div>
                `;
            },
          },
          {
            data: "si_valider",
            defaultContent: false,
            visible: false,
          },
          {
            data: "si_archiver",
            defaultContent: false,
            visible: false,
          },
        ],
        language: {
          lengthMenu: '<i class="fa fa-eye fa-fw"></i> _MENU_',
          search: '<i class="fa fa-search fa-fw"></i> ',
          info: "_START_ à _END_ sur _TOTAL_ éléments",
          paginate: {
            previous: '<i class="fa fa-chevron-left fa-fw"></i>',
            next: '<i class="fa fa-chevron-right fa-fw"></i>',
          },
        },
      });

      $("#avisInfosTable").on(
        "error.dt",
        function (e, settings, techNote, message) {
          console.error("DataTables error:", message);
        }
      );

      $("#avisInfosTable tbody").on("click", "button", function () {
        const offreId = $(this).data("id");
        const action = $(this).data("action");
        const offre = avisInfos.find((o) => o.id === offreId);

        if (action === "changer") {
          handleShow(offre);
        } else if (action === "visualiser") {
          handleOpenDetailModal(offre);
        }
      });

      const initializeSelectpicker = () => {
        if ($.fn.selectpicker) {
          $("#etat").selectpicker({
            liveSearch: true,
          });
        } else {
          console.warn("Bootstrap Selectpicker not available.");
        }
      };

      setTimeout(initializeSelectpicker, 100);

      return () => {
        table.destroy();
        if ($.fn.selectpicker) {
          $("#etat").selectpicker("destroy");
        }
      };
    }
  }, [avisInfos]);

  return (
    <section className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="m-0" style={{ color: "#858796" }}>
          Avis & infos
        </h2>
        <Button
          variant="primary"
          className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
          style={{ width: "170px", textDecoration: "none" }}
          onClick={handleOpenAddModal}
        >
          <FontAwesomeIcon icon={faPlus} className="fas fa-sm text-white-50" />
          Ajouter un avis
        </Button>
      </div>

      {message && (
        <div
          className={`alert ${
            message.includes("succès") ? "alert-success" : "alert-danger"
          }`}
          role="alert"
        >
          {message}
        </div>
      )}

      <div className="card shadow-sm" style={{ maxWidth: "100%" }}>
        <div
          className="card-header"
          style={{ color: "#5A5C69", background: "#F8F9FC" }}
        >
          <div className="filter">
            <div className="row">
              <div className="col-sm-6 col-md-3 filters-item">
                <div
                  className="filters-label mb-2"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#5A5C69",
                  }}
                >
                  <FontAwesomeIcon icon={faFilter} className="" />{" "}
                  <span className=" ms-1"> État </span>
                </div>
                <div className="filters-input">
                  <select
                    id="etat"
                    name="etat"
                    onChange={() => filterAvis()}
                    className="form-control selectpicker bordered"
                    data-live-search="true"
                  >
                    <option value="all">Tous</option>
                    <option value="2">Offre pour la validation</option>
                    <option value="3">Validée</option>
                    <option value="10">Archivée</option>
                  </select>
                  <i
                    className="fas fa-caret-down fa-sm"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "70%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#000",
                    }}
                  />
                </div>
              </div>
              <input
                type="hidden"
                value="all"
                name="employeur"
                id="employeur"
              />
              <input type="hidden" value="all" name="traduit" id="traduit" />
            </div>
          </div>
        </div>

        <div className="card-bod">
          <div className="table-responsive" style={{ fontSize: "11px" }}>
            <table
              id="avisInfosTable"
              className="table table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th>Titre</th>
                  <th>Date limite</th>
                  <th>Client</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal show={showAddModal} onHide={handleCloseAddModal} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#858796" }}>Nouveau avis</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <input
              type="hidden"
              name="_token"
              value="za8y7uqCskRLxgUgjuLj1jdcdvP2JpDm2fRLqdES"
            />

            <Form.Group className="mb-3">
              <Form.Label
                className="ms-1"
                style={{ fontSize: "16px", color: "#858796" }}
              >
                Titre <span className="">*</span>
              </Form.Label>
              <Editor
                apiKey="klj83yy4j4btu0s11oheti6rj6kwwgj0lnbtwunqvvqeipyf"
                id="titre"
                value={titreContent}
                init={{
                  height: 400,
                  plugins: "table lists",
                  toolbar:
                    "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist",
                }}
                onEditorChange={(content) => setTitreContent(content)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label
                className="ms-1"
                style={{ fontSize: "16px", color: "#858796" }}
              >
                Description <span className="">*</span>
              </Form.Label>
              <Editor
                apiKey="klj83yy4j4btu0s11oheti6rj6kwwgj0lnbtwunqvvqeipyf"
                id="content"
                value={descriptionContent}
                init={{
                  height: 400,
                  plugins: "table lists",
                  toolbar:
                    "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist",
                }}
                onEditorChange={(content) => setDescriptionContent(content)}
              />
            </Form.Group>

            <Row className="mb-3 ms-1">
              <Col md={6}>
                <Form.Group style={{ paddingRight: "20px" }}>
                  <Form.Label
                    className=""
                    style={{ fontSize: "16px", color: "#858796" }}
                  >
                    Date limite <span className="">*</span>
                  </Form.Label>
                  <Form.Control
                    type="datetime-local"
                    id="date_limite"
                    defaultValue="2025-02-28"
                  />
                </Form.Group>
              </Col>
              <Col md={6} style={{ paddingRight: "20px" }}>
                <Form.Group controlId="type_offre">
                  <Form.Label
                    className=""
                    style={{ fontSize: "16px", color: "#858796" }}
                  >
                    Avis fixe <span className="">*</span>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="type_offre"
                    value={si_fixe}
                    onChange={handleTypeChange}
                    className="bordered"
                  >
                    <option value="1">Non</option>
                    <option value="2">Oui</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3 ms-1" style={{ paddingRight: "10px" }}>
              <Form.Label
                className="ms-"
                style={{ fontSize: "16px", color: "#858796" }}
              >
                Lien <span className="">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="lien"
                value={lien}
                onChange={handleLienChange}
                className="form-control"
                placeholder="Entrez un lien"
              />
            </Form.Group>

            <div className="text-end">
              <Button variant="success" type="submit">
                Ajouter
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <JobOfferModal
        show={showDetailModal}
        handleClose={handleCloseDetailModal}
        offre={selectedOffre}
      />
      <AnnouncementTypeChanger
        showModal={showModal}
        handleClose={handleClose}
        offreId={selectedOffre?.id}
      />
    </section>
  );
};

export default AvisInfos;
